import { createFileRoute } from '@tanstack/react-router';
import { CreateTicketPage } from '@/features/it-service/pages';

export const Route = createFileRoute('/it-service/changerequests/new')({
  component: () => <CreateTicketPage ticketType="changerequest" />,
});
